import React, {useEffect, useState} from "react";
import {connect} from "react-redux";
import {withStyles} from "@material-ui/styles";
import Grid from "@material-ui/core/Grid";
import ViewPageLayout from "../../../../../../../ui/ViewPageLayout";
import {getPersonOrganizationList} from "../../../../store/actions";
import InfoCard from "../../../../../../../Study/Requests/pages/StudyRequestView/StudyRequestInfo/InfoCard";
import ApartmentIcon from '@material-ui/icons/Apartment';
import StateInfoField from "../../../../../../../Study/Requests/pages/StudyRequestView/StudyRequestInfo/StateInfoField";
import ImageBox from "../../../../../../../ui/InfoDrawer/components/ImageBox";
import useManageEmployees from "../../../../../../../Organizations/hooks/useManageEmployees";
import DeleteConfirmationModal from "../../../../../../../ui/DeleteConfirmationModal";
import ManageEmployee
  from "../../../../../../../Organizations/pages/OrganizationsEdit/components/OrgStructure/components/Employees/ManageEmployee";

const defaultConfirmDelete = {
  open: false,
  orgId: null,
  staffId: null
};

const defaultManage = {
  open: false,
  orgId: null,
  data: {
    departmentId: null,
    postId:null,
    startDate:null,
    endDate:null,
    id:null
  }
}

const PersonOrganizations = ({classes,personId, editmode,
                               getPersonOrganizationList, personOrgList}) => {
  const [confirmDeleteEmployee, setConfirmDeleteEmployee] = useState(defaultConfirmDelete);
  const [manageEmployee, setManageEmployee] = useState(defaultManage);
  const { deleteEmployee, updateEmployee } = useManageEmployees(() => getPersonOrganizationList(personId));

  useEffect(() => {
    getPersonOrganizationList(personId);
  },[personId]);

  return (
    <ViewPageLayout header="Организации">
      <DeleteConfirmationModal
        modalText="Удалить сотрудника из организации?"
        open={confirmDeleteEmployee.open}
        onConfirm={() => {
          if (confirmDeleteEmployee && confirmDeleteEmployee.orgId && confirmDeleteEmployee.staffId) {
            deleteEmployee(confirmDeleteEmployee.orgId, confirmDeleteEmployee.staffId);
          }
          setConfirmDeleteEmployee(defaultConfirmDelete);
        }}
        handleClose={() => setConfirmDeleteEmployee(defaultConfirmDelete)}
      />
      <ManageEmployee
        open={manageEmployee.open}
        handleClose={() => setManageEmployee(defaultManage)}
        updateEmployee={updateEmployee}
        employee={manageEmployee.data}
        orgId={manageEmployee.orgId}
      />
      <Grid container spacing={1} justify="flex-start" alignItems="flex-start">
        {personOrgList && personOrgList.length > 0 && personOrgList.map(item => (
          <Grid key={`staffOrgGrid${item.id}`} item xs={12} sm={6}>
            <div id={`staffOrg${item.id}`}>
            <InfoCard title={item.orgName}
                      subheader={item.isDefault ? 'Организация по умолчанию' : ''}
                      icon={<ApartmentIcon/>}
                      contentTitle={<ImageBox image={item.logo}/> }
                      contentBody={
                        <>
                          <StateInfoField field="Подразделение" value={item.depName || '-'}/>
                          <StateInfoField field="Должность" value={item.postName || '-'}/>
                          <StateInfoField field="Период" value={item.staffPeriod}/>
                        </>}
                      linkTo={item.id ? `/work/app/organization/${item.id}` : null}
                      cardActions={[
                        {
                          label: "Удалить",
                          onClick: () => setConfirmDeleteEmployee({
                            open: true,
                            orgId: item.id,
                            staffId: item.staffId
                          })
                        },
                        {
                          label: "Изменить",
                          onClick: () => setManageEmployee({
                            open: true,
                            orgId: item.id,
                            data: {
                              departmentId: item.depId,
                              postId: item.postId,
                              startDate: item.startDate,
                              endDate: item.endDate,
                              id: item.staffId
                            }
                          })
                        },
                        !item.isDefault &&
                        {
                          label: "По умолчанию",
                          onClick: () => {}
                        }
                      ]}
            /></div>
          </Grid>
        ))}
      </Grid>
    </ViewPageLayout>
  );
}

const mapStateToProps = state => ({
  personOrgList: state.persons.personOrgList
});

const mapDispatchToProps = dispatch => ({
  getPersonOrganizationList: (id) => dispatch(getPersonOrganizationList(id))
});

export default connect(mapStateToProps, mapDispatchToProps)(PersonOrganizations);
